import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaContabilidad } from '../_contabilidad.js';

/**
 * La nómina, pantalla 3a del diseño. Vive dentro del grupo `_contabilidad`, así que el guardián de
 * nivel 3 ya se aplicó: el operario y el jefe de operarios no llegan acá ni saben que existe.
 *
 * El componente llega a pedido por la razón de sus hermanos: arrastra la consulta y los cinco
 * ganchos de la nómina, y el operario no debe descargar nada de eso. Adjudicación 41.
 */
export const rutaNomina = createRoute({
  getParentRoute: () => rutaContabilidad,
  path: '/nomina',
  component: lazyRouteComponent(() => import('./nomina-pantalla.js'), 'RutaNomina'),
});
